export interface DropdownArrowIconProps {
  isDisabled?: boolean;
}
export const DropdownArrowIcon = ({
  isDisabled = false,
}: DropdownArrowIconProps) => {
  const arrowColor = isDisabled ? "#C7C7C7" : "#1F2A37";
  return (
    <svg
      aria-hidden={true}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Drowndown Arrow</title>
      <path
        d="M18 9L12.2827 14.7168C12.2077 14.7918 12.106 14.834 12 14.834C11.894 14.834 11.7923 14.7918 11.7173 14.7168L6 9"
        stroke={arrowColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
